import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


//import { NgxSpinnerModule } from 'ngx-spinner';
import { AutofocusDirective } from './directive/autofocus.directive';
import { ConfigService } from './services/config.service';
import { MatDialogModule } from '@angular/material/dialog';




@NgModule({
  //imports: [CommonModule, NgxSpinnerModule],
  imports: [CommonModule, MatDialogModule],
  declarations: [AutofocusDirective],
  //exports: [NgxSpinnerModule, AutofocusDirective],
  exports: [AutofocusDirective],
  providers: [
	  ConfigService
  ],
})
export class BaseModule { }
